import { inject } from '@angular/core';
import { ApolloLink, InMemoryCache } from '@apollo/client/core';
import { provideApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';

import { environment } from '@env';
import { createAuthLink } from './graphql-auth.link';
import { AccessTokenService } from './http/access-token.service';

export const createApolloProvider = () => {
    return provideApollo(() => {
        const authService = inject(AccessTokenService);
        const authLink = createAuthLink(authService);

        const namedOperationsLink = new ApolloLink((operation, forward) => {
            const uri = environment.gatewayUrl + '/graphql';

            const { operationName } = operation;
            const contextUri = `${uri}/${operationName ? `?o=${operationName}` : ''}`;

            const context = operation.getContext();

            operation.setContext({ ...context, uri: contextUri });

            return forward(operation);
        });

        const http = inject(HttpLink)
            .create({ uri: environment.gatewayUrl + '/graphql' });

        return {
            cache: new InMemoryCache({ resultCaching: false }),
            defaultOptions: {
                query: {
                    fetchPolicy: 'no-cache',
                    errorPolicy: 'all',
                },
            },
            devtools: {
                enabled: !environment.production,
            },
            link: ApolloLink.from([authLink, namedOperationsLink, http]),
        };
    });
};

export interface GraphQLFormattedError {
    message?: string
    extensions?: {
        code: string
    }
}